import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EnquiryService {

  ApiURL = environment.ApiURL + '/admin';
  public headers_token: HttpHeaders;

  constructor(private http: HttpClient) {
    this.headers_token = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem('token')
    });
  }

  getAllEnquiry(): Observable<any> {
    return this.http.get(this.ApiURL + '/Enquiries', { headers: this.headers_token });
  }

 deleteEnquiry(Id: any): Observable<any> {
    return this.http.delete(this.ApiURL + '/Enquiries/Delete/' + Id, { headers: this.headers_token });
  }

}
